import { polarToCartesian } from './polar-to-cartesian';

/**
 * Generates an SVG arc path string given a center, radius, start, and end angles.
 * The arc is drawn clockwise from startAngle to endAngle.
 *
 * @param cx - The x-coordinate of the circle's center.
 * @param cy - The y-coordinate of the circle's center.
 * @param radius - The radius of the circle.
 * @param startAngle - The starting angle (in degrees) of the arc.
 * @param endAngle - The ending angle (in degrees) of the arc.
 * @returns A string that represents the SVG path for the arc.
 */
export const describeArc = (cx: number, cy: number, radius: number, startAngle: number, endAngle: number): string => {
  const start = polarToCartesian(cx, cy, radius, startAngle);
  const end = polarToCartesian(cx, cy, radius, endAngle);
  const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
  return ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 1, end.x, end.y].join(' ');
};
